import { getToken } from "~/storages/token";
import {
  HttpTransportType,
  HubConnection,
  HubConnectionBuilder,
} from "@microsoft/signalr";
import { setCookieToken } from "~/storages/cookie";

export const createSocketInstance = (
  socketUrl: string,
  socket: HubConnection | undefined,
) => {
  const token = getToken();

  if (!socket && token) {
    setCookieToken(token);

    socket = new HubConnectionBuilder()
      .withUrl(socketUrl, {
        transport: HttpTransportType.WebSockets,
        skipNegotiation: true,
      })
      .withAutomaticReconnect()
      .build();

    return socket;
  }
};
